'use client';

import { Button, Pagination, Popover } from 'antd';
// warning.svg
import type { ReactNode } from 'react';
import { useRef, useState } from 'react';

import styles from './index.less';

export interface ExamplePopoverPageItemList {
  title?: ReactNode;
  content?: ReactNode;
  buttonTitle?: string;
  buttonOnClick?: () => void;
}

export interface ExamplePopoverPageProps {
  items: ExamplePopoverPageItemList[];
}

export interface ExamplePopoverComponentProps {
  pages?: ExamplePopoverPageProps[];
  pageTitle?: string;
}
export interface ExamplePopoverProps extends ExamplePopoverComponentProps {
  className?: string;
  children?: ReactNode;
}

export default function ExamplePopover(props: ExamplePopoverProps) {
  const { pages, pageTitle, children } = props;
  const [pageIndex, setPageIndex] = useState<number>(1);
  const containerRef = useRef<HTMLDivElement>(null);
  const targetPages = pages ?? [];

  const title = <div className={styles.contentTitle}>{pageTitle}</div>;

  const popOverContent = () => {
    if (targetPages.length === 0) {
      return <></>;
    }

    const details = targetPages[pageIndex - 1].items.map((item, index) => {
      return (
        <div key={index} className={styles.contentDetailItem}>
          <div className={styles.contentDetailItemTitle}>{item.title}</div>
          {(item.content ?? '').toString().length > 0 && (
            <div className={styles.contentDetailItemContent}>{item.content}</div>
          )}
          {item.buttonTitle && (
            <div className={styles.contentDetailBottomButton}>
              <Button onClick={item.buttonOnClick} type="primary">
                {item.buttonTitle}
              </Button>
            </div>
          )}
        </div>
      );
    });

    return (
      <div className={styles.contentContainer}>
        <div className={styles.pages}>{details}</div>
        {targetPages.length > 1 && (
          <div className={styles.bottomContainer}>
            <Pagination
              current={pageIndex}
              defaultCurrent={1}
              onChange={(_pageIndex) => {
                setPageIndex(_pageIndex);
              }}
              pageSize={1}
              showQuickJumper={false}
              showSizeChanger={false}
              size="small"
              total={targetPages.length}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div ref={containerRef} className={styles.container}>
      {targetPages.length > 0 && (
        <Popover
          arrow={false}
          content={popOverContent()}
          getPopupContainer={(trigger) => {
            const parent = trigger.parentElement!;

            return parent;
          }}
          mouseLeaveDelay={0.3}
          placement="topRight"
          title={title}
          trigger="hover"
        >
          {children}
        </Popover>
      )}
      {targetPages.length === 0 && children}
    </div>
  );
}
